import { BaseParameterDto } from './../base-parameter-dto';

export class RegisterWithoutRecaptchaParametersDto extends BaseParameterDto {
  customerId: string;
  checkDigit: number;
  email: string;

  override getQueryString(): string {
    const encodedCustomerId = encodeURIComponent(this.customerId);
    const encodedEmail = encodeURIComponent(this.email || '');

    return `?customerId=${encodedCustomerId}&checkDigit=${this.checkDigit}&email=${encodedEmail}`;
  }
}
